import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgChevronDown = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.34426 6.56859C3.54572 6.3537 3.88324 6.34282 4.09812 6.54427L8.00001 10.2023L11.9019 6.54427C12.1168 6.34282 12.4543 6.3537 12.6558 6.56859C12.8572 6.78348 12.8463 7.121 12.6315 7.32245L8.36478 11.3225C8.15963 11.5148 7.8404 11.5148 7.63525 11.3225L3.36858 7.32245C3.15369 7.121 3.14281 6.78348 3.34426 6.56859Z"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgChevronDown)
const IconSvgChevronDown = createIcon(ForwardRef, 'SvgChevronDown')
export default IconSvgChevronDown
